export const ACTION_AREA = '/OsimDelivery/GetAreaDelivery';

export const ACTION_PROVINCE = '/OsimDelivery/GetProvinceDelivery';

export const ACTION_CITY = '/OsimDelivery/GetCityDelivery';

export const ACTION_ZIPCODE = '/OsimDelivery/GetZipCode';

export const GET_SHIPPING_FEE = '/osimcart/GetShipping';
